import Menu from '@mui/icons-material/Menu';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function MenuIcon(props: FixMe) {
  return <Menu {...props} />;
}

export default MenuIcon;
